import { Flex, rem } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { createDomName } from '../../../utils/dom/identifying';
import { range } from '../../../utils/general/lambda';
import { BokehSkeleton } from '../../bokeh';

/**
 * Component to display progress of chat/history loading.
 */
export function ChatPreloader({
  id = createDomName('chat-preloader'),
  className = createDomName('chat-preloader'),
}: IBaseDomElementProps) {
  return (
    <Flex
      id={id}
      className={className}
      flexDirection={'column'}
      alignItems={'center'}
      width={'100%'}
      flexGrow={1}
      overflow={'hidden'}
    >
      <Flex
        id={createDomName(id, 'history')}
        className={createDomName(className, 'history')}
        width={'100%'}
        overflow={'hidden'}
        flexDirection={'column'}
        height={'100%'}
        padding={`0 ${rem(16)}`}
      >
        {range(20).map((it) => (
          <BokehSkeleton
            key={it}
            className={createDomName(className, 'message')}
            marginBottom={rem(16)}
            padding={rem(20)}
            borderRadius={rem(4)}
          />
        ))}
      </Flex>
    </Flex>
  );
}
